var render = function render(_c,_vm){return _c('b-button',_vm._b({class:['icon-button', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'b-button',_vm.data.attrs,false),[_c('span',{staticClass:"btn-text"},[_vm._t("default")],2),_c('lazy-icon',{staticClass:"btn-icon",attrs:{"icon":_vm.props.icon,"font-scale":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }